var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "nativewind/jsx-runtime";
import EmptyViewText from '@/components/empty/EmptyViewText';
import { ScreenLayout } from '@/components/ScreenLayout';
import useAppComponents from '@/hooks/useAppComponents';
import { FlashList } from '@shopify/flash-list';
import { useInfiniteQuery } from '@tanstack/react-query';
import { View } from 'react-native';
import UpvotedPlaceItem from './components/UpvotedPlaceItem';
export default function ConquererUpvoteScreen() {
    var _a;
    const { api } = useAppComponents();
    const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery({
        queryKey: ['PlacesUpvoted'],
        queryFn: (_a) => __awaiter(this, [_a], void 0, function* ({ pageParam }) {
            const result = yield api.listUpvotedPlacesPost({
                nextToken: pageParam,
                limit: 20,
            });
            return result.data;
        }),
        getNextPageParam: lastPage => {
            return lastPage.nextToken;
        },
        initialPageParam: undefined,
    });
    const places = (_a = data === null || data === void 0 ? void 0 : data.pages.flatMap(page => { var _a; return (_a = page.places) !== null && _a !== void 0 ? _a : []; })) !== null && _a !== void 0 ? _a : [];
    return (_jsxs(ScreenLayout, { isHeaderVisible: false, children: [_jsx(View, { className: "border-b-[1px] border-b-gray-20" }), _jsx(FlashList, { data: places, renderItem: ({ item }) => (_jsxs(_Fragment, { children: [_jsx(View, { className: "p-5", children: _jsx(UpvotedPlaceItem, { item: item }) }), _jsx(View, { className: "h-[1px] bg-gray-20" })] })), onEndReached: () => {
                    if (hasNextPage && !isFetchingNextPage) {
                        fetchNextPage();
                    }
                }, onEndReachedThreshold: 0.5, ListEmptyComponent: _jsx(EmptyViewText, {}), ListFooterComponent: _jsx(View, { className: "pb-[100px]" }) })] }));
}
